import React, { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import App from "../App";
import ErrorComponent from "../ui/ErrorComponent";

const handleReset = () => {
  if (window.history.back) return window.history.back();

  if (localStorage.getItem("auth") === "telegram") {
    window.location.replace("/mini-dashboard");
  } else {
    window.location.replace("/dashboard");
  }
};

function AppWithErrorHandler() {
  const [componentStack, setComponentStack] = useState(null);

  return (
    <ErrorBoundary
      onReset={() => {
        setComponentStack(null);
        handleReset();
      }}
      onError={(error, info) => {
        console.log("Error:", error);
        console.log("Component Stack:", info?.componentStack);
        setComponentStack(info?.componentStack);
      }}
      fallbackRender={(props) => (
        <ErrorComponent {...props} componentStack={componentStack} />
      )}
    >
      <div className="notranslate">
        <App />
      </div>
    </ErrorBoundary>
  );
}

export default AppWithErrorHandler;
